import React, {useEffect} from "react";
import { useState } from "react";
import TablaGestion from "../../components/shared/layout/Table";
import { Personas } from "../../structure/Tables";
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';
import {Box, Modal, Select} from "@mui/material";
import Loader2 from "../../components/shared/layout/Loader2";
import { ModalsubPersonaCreator } from "../../components/shared/layout/ModalsubPersonaSelector";
import { IOSSwitch } from "../../components/shared/Litles/switch";
import MenuItem from "@mui/material/MenuItem";
import {instance} from "../../utilities";
import {debugHtml} from "../../utilities/Utilities";
import LocalPrintshopTwoToneIcon from "@mui/icons-material/LocalPrintshopTwoTone";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 250,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

export default function PersonasView(props){
    const {data=[], addRow, getData, borrarRegistro, backOption,backFunction,openEdit,openDelete, title, setDataResponse, setCatchResponse, filters, setFilters, menu_id}=props;
    const [listVidaReligiosa, setListVidaReligiosa] = useState([]);
    const [dataSet, setDataSet] = useState(data);
    const [opensub, setOpensub]=useState(false)
    const [loader, setLoader2]=useState(false)

    const handleClosesub =()=>{
        setOpensub(false);
        getData(null)
    }

    

    const [sortModel, setSortModel] = React.useState([
        {
          field: 'nombrecompleto',
          sort: 'asc',
        },
      ]);

    const printReporte = async(e) => {
        const title = `Listado de ${filters.f_hermanas ? 'Hermanas' : 'Personas'}${filters.f_fallecido ? ' Fallecidas' : ''}${filters.f_SNID ? ' Sin Identificacion' : ''}${filters.f_retirados === 'SI' ? ' Retiradas' : (filters.f_retirados === 'NO' ? ' Activas' : '')}`;

        const data = {
            title,
            hermanas: filters.f_hermanas,
            SNID: filters.f_SNID,
            fallecido: filters.f_fallecido,
            estado: filters.f_retirados,
        }

        instance.post(`/Formatos/printListPersona/${menu_id}`, data)
            .then(async response => {
                debugHtml(response.data);
            }).catch((error)=>{})
    }

    const botonesAccion = [
        {
        field: "action",
        headerName: <div  style={{marginBottom:"-10px"}}>
            <AddTwoToneIcon titleAccess="Agregar" onClick={()=>setOpensub(true)}/>
            <LocalPrintshopTwoToneIcon titleAccess="Imprimir Listado" onClick={printReporte}/>
        </div>,
        width: 85,
        
        renderCell: (params) => {
            return (
            <div className="cellAction" style={{ display:"flex"}}>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} onClick={async(e)=>{
                    if(openEdit || typeof openEdit === "function"){
                        openEdit(params.row, "persona")
                    }
                }} >
                    {<EditTwoToneIcon titleAccess="Editar" /> }
                </div>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} onClick={async(e)=>{
                    if(openDelete || typeof openDelete === "function"){
                        openDelete(params.row, "persona")
                    }
                }}>
                    {openDelete && <DeleteTwoToneIcon titleAccess="Borrar" /> }
                </div>
            </div>
            );
        },
        },
    ];

    useEffect(()=>{
        if (data && data.length > 0){
            instance.get(`/PerfilReligioso/ListAll`)
                .then(res=>{
                    if(res.status === 200){
                        const vidaReligiosa = res.data?.data ?? [];
                        setListVidaReligiosa(vidaReligiosa);
                        const newData = data.map((item)=>{
                            const fecharetiro = vidaReligiosa.find(x => x.persona_id === item.idreal)?.fecha_retiro;
                            return {
                                ...item,
                                retirado: fecharetiro ? 'Retirado' : 'Activo',
                            }
                        })
                        setDataSet(newData);
                    }
                })
        }
        else{
            setDataSet(data);
        }
    }, [data])

    return(
        <React.Fragment>
            <Modal
                hideBackdrop
                open={opensub}
                onClose={handleClosesub}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <>
                <Box sx={{ ...style, width: 580 }}>
                <Loader2 onLoader={loader}/>
                    <h2 id="parent-modal-title">Nuevo</h2>
                    <ModalsubPersonaCreator
                        setDataResponse={setDataResponse}
                        setCatchResponse={setCatchResponse}
                        setLoader={setLoader2}
                        handleClose={handleClosesub}
                    />
                </Box>
                </>
            </Modal>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <h3>Hermanas</h3>
                    <IOSSwitch 
                        checked={filters.f_hermanas} 
                        onChange={(e)=>{setFilters(prev=>({...prev, f_hermanas:e.target.checked}))}}
                    /> 
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <h3>Sin N° identificación</h3>
                    <IOSSwitch 
                        checked={filters.f_SNID} 
                        onChange={(e)=>{setFilters(prev=>({...prev, f_SNID:e.target.checked}))}}
                    /> 
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <h3>Fallecido</h3>
                    <IOSSwitch
                        checked={filters.f_fallecido}
                        onChange={(e)=>{setFilters(prev=>({...prev, f_fallecido:e.target.checked}))}}
                    />
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', width: 95}}>
                    <h3>Estado</h3>
                    <Select
                        value={filters.f_retirados}
                        labelId="Retirados"
                        label="Retirados"
                        fullWidth
                        onChange={(e) => {setFilters(prev=>({...prev, f_retirados:e.target.value}))}}
                    >
                        <MenuItem key={0} value='T'>TODOS</MenuItem>
                        <MenuItem key={1} value='NO'>ACTIVO</MenuItem>
                        <MenuItem key={2} value='SI'>RETIRADO</MenuItem>
                    </Select>
                </div>
            </div>
            <TablaGestion 
                botones ={botonesAccion}
                data={dataSet
                    .filter(x=> (
                        (filters.f_hermanas && x.estado) || !filters.f_hermanas)
                        && ((filters.f_SNID && !x.numeroidentificacion) || !filters.f_SNID )
                        && ((filters.f_fallecido && x.fallecido) || !filters.f_fallecido)
                        && ((filters.f_retirados === 'SI' && !!listVidaReligiosa.find(item => item.persona_id === x.idreal)?.fecha_retiro) || (filters.f_retirados === 'NO' && !listVidaReligiosa.find(item => item.persona_id === x.idreal)?.fecha_retiro) || filters.f_retirados === 'T')
                    )
                }
                sortModel={sortModel} 
                setSortModel={setSortModel} 
                formato = {Personas} 
                titulo={
                    <>
                        {backOption?<KeyboardBackspaceTwoToneIcon onClick={backFunction} sx={{cursor:"pointer"}}/>:null}
                        {title}
                    </>} 
            />
        </React.Fragment>
    )
}
